import axios from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_RESULTS_BACKEND_URL,
  responseType: 'json',
  headers: { 'Content-type': 'application/json' },
  timeout: 5000,
});
